// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ohDO","title":"styles_title__1Mtuy"};